import { styled, css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { colors, fontWeights } }) => css`
    align-items: center;
    display: flex;
    gap: 0 0.25rem;
    flex-wrap: wrap;
    user-select: none;

    .text {
      cursor: pointer;
      font-weight: ${fontWeights.medium};
      letter-spacing: 0;
      word-break: break-all;

      span {
        color: ${colors.brandDarkTint30};

        &:hover {
          background: ${colors.brandPrimaryTint90};
          border-radius: 0.25rem;
          color: ${colors.brandPrimary};
        }
      }
    }

    @media print {
      padding: 0 0.25rem;

      .text {
        font-size: 0.66rem;
      }
    }
  `}
`;
